import React from 'react';
import { twMerge } from 'tailwind-merge';
type SelectFieldProps = {
  ariaLabel: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  className?: string;
};
export function SelectField({
  ariaLabel,
  value,
  options,
  onChange,
  className
}: SelectFieldProps) {
  return <div className={twMerge('relative h-[24px] w-[96px]', className)} data-id="element-873" data-mp="3ku7w4m9d5ca7">
      <select aria-label={ariaLabel} value={value} onChange={e => onChange(e.target.value)} className="h-full w-full appearance-none rounded-[4px] border border-pf-line bg-white pl-2 pr-6 text-[12px] text-pf-ink outline-none focus-visible:border-pf-blue-line" data-id="element-874" data-mp="3pt1asi0dz9by">
        
        {options.map(o => <option key={o} value={o} data-id="element-875" data-mp="7melivln824h">
            {o}
          </option>)}
      </select>
      <svg viewBox="0 0 8 5" className="pointer-events-none absolute right-[8px] top-1/2 h-[4px] w-[7px] -translate-y-1/2 text-[#5b6066]" fill="currentColor" data-id="element-876" data-mp="25dzf506u1prh">
        <path d="M0 0 H8 L4 5 Z" data-id="element-877" data-mp="29gm7d27f1cp7" />
      </svg>
    </div>;
}